const API_CATALOGS = process.env.CATALOGS_API_URL || process.env.VUE_APP_CATALOGS_API_URL;
const fetchData = (typeof fetch === 'function') ? fetch : require('node-fetch');

const NodeCache = require('node-cache');
const http = require('http');
const https = require('https');

const {
  catalogsAvailable,
  cacheConfig,
} = require('../constants');

const cache = new NodeCache(
  {
    stdTTL: cacheConfig.cacheDuration,
    checkperiod: cacheConfig.checkPeriod,
  },
);

const httpAgent = new http.Agent({ keepAlive: true });
const httpsAgent = new https.Agent({ keepAlive: true });

const agent = _parsedURL => (_parsedURL.protocol === 'http:' ? httpAgent : httpsAgent);

const API_URL = API_CATALOGS && API_CATALOGS.slice(-1) === '/' ? API_CATALOGS.slice(0, -1) : API_CATALOGS;

const hasParams = params => Object.entries(params).length > 0;

/**
 *
 * @param {string} catalogName
 * @param {string} keys
 * @return {Promise<array|null>} elements consumed
 */
const getCatalogSatByKeys = async (catalogName, keys) => {
  const fromBody = {
    keys,
  };

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(fromBody),
  };

  if (agent) {
    Object.assign(options, agent);
  }

  const objectReturn = catalogsAvailable[catalogName];

  if (!objectReturn) {
    return null;
  }

  if (!API_URL) {
    throw new Error('Api catalogs sat is not defined');
  }

  try {
    const response = await fetchData(`${API_URL}/api/${catalogName}/by-keys`, options);

    if (!response.ok) {
      return [];
    }

    const responseData = await response.json();

    return responseData[objectReturn] || null;
  } catch (error) {
    return [];
  }
};

/**
 * @param {string} catalogName
 * @param {object} params data in a query string.
 * @return {Promise<array|null>} elements consumed
 */
const getCatalogSatAll = async (catalogName, params = {}) => {
  const queryString = { ...{ Active: true }, ...params };
  const qs = new URLSearchParams(queryString);
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  if (agent) {
    Object.assign(options, agent);
  }

  const objectReturn = catalogsAvailable[catalogName];

  if (!objectReturn) {
    return null;
  }

  if (!hasParams(params)) {
    const hasCache = cache.has(catalogName);

    if (hasCache) {
      const catalog = cache.get(catalogName);
      return catalog;
    }
  }

  if (!API_URL) {
    throw new Error('Api catalogs sat is not defined');
  }

  const response = await fetchData(`${API_URL}/api/${catalogName}/all?${qs}`, options);

  if (!response.ok) {
    return [];
  }

  try {
    const responseData = await response.json();

    if (!hasParams(params)) {
      cache.set(catalogName, responseData[objectReturn]);
    }

    return responseData[objectReturn] || null;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('ApiCatalogSat', catalogName, error);
    return [];
  }
};

/**
 * @param {string} catalogName
 * @param {string} key Value to compare
 * @return {Promise<object|null>} First item found
 */
const getCatalogSatByKey = async (catalogName, key) => {
  const [catalog] = await Promise.all([
    getCatalogSatAll(catalogName, { key, Active: '' }),
  ]);

  if (catalog && catalog.length > 0) {
    return catalog[0];
  }

  return null;
};

module.exports = {
  getCatalogSatAll,
  getCatalogSatByKey,
  getCatalogSatByKeys,
};
